import BaseModel from "../core/BaseModel";
export default class CompanyGroupModel extends BaseModel {
  constructor() {
    super(
      {
        name: "company_group",
        tableName: "company_group",
        label: "Quản Lý Tập Đoàn",
        display_key: "name",
      },
      {
        stt: { 
          name: "stt", 
          label: "STT",
          class: 'center', 
          computed: (data, index) => {
            data.stt = index + 1;
          }
        },
        id: {
          name: "id",
          type: "Number",
          label: "ID",
          primaryKey: true,
          display: false,
        },

        name: {
          name: "name",
          type: "String",
          label: "Tên tập đoàn",
          filter: { type: "input", match: "contains" },
        },
        phone: {
          name: "phone",
          type: "String",
          label: "Số điện thoại",
          filter: { type: "input", match: "contains" },
        },
        email: {
          name: "email",
          type: "String",
          label: "Email",
          filter: { type: "input", match: "contains" },
        },
        addr: {
          name: "address",
          type: "String",
          label: "Địa chỉ",
          filter: { type: "input", match: "contains" },
        },
        contact_name: {
          name: "contact_name",
          type: "String",
          label: "Người đại diện",
          filter: { type: "input", match: "contains" },
        },
        sync_id: {
          name: "sync_id",
          type: "String",
          label: "ID đồng bộ",
          display: false,
        },

        active : {
          name: 'active', 
          type: "Selection", 
          custom: 'SelectionText',
          label: 'Trạng thái',
          // class: 'center',
          width: 10,
          options: [
            {label: "Đang hoạt động",value: true},
            {label: "Ngừng hoạt động",value: false}
          ],
          filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
          display: false,
        },
        deleted: {
          name: "deleted",
          label: "Xóa",
          type: "Checkbox",
          display: false,
        },
        created_at : { 
          name: 'created_at', 
          type: "Datetime", 
          label: 'Ngày tạo',
          filter: { type: 'DateRange', match: 'contains'},
          display : false
        },
        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối"
        },
      }
    );
  }
}
